import { connect } from "react-redux";
import FinalReflection from "../../components/Journal/FinalReflection";
import { saveJournalSection } from "../../actions/journal";

const mapStateToProps = state => {
  return {
    content: state.journal.finalReflection
  };
};

export default connect(mapStateToProps, { save: saveJournalSection })(
  FinalReflection
);
